import { render, staticRenderFns } from "./cPie.vue?vue&type=template&id=4be35326&scoped=true"
import script from "./cPie.vue?vue&type=script&lang=js"
export * from "./cPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be35326",
  null
  
)

export default component.exports